import {useEffect} from "react";
import {useFormContext} from "react-hook-form";
import {DateUtil} from "base/format/utilities";
import Grid from "@mui/material/Grid";
import FormDatePicker from "base/form/components/FormDatePicker";

const FormDatePickerCombo = ({
    startDateName,
    startDateLabel,
    endDateName,
    endDateLabel,
    minStartDate = null,
    maxEndDate = null,
    disableFuture = false,
    required = false,
    disabled = false,
}) => {
    const {watch, setValue} = useFormContext();

    const startDate = watch(startDateName);

    useEffect(() => {
        // Keep end date always equal to start date and validate it
        // FormDatePicker stores values in API date string format, so reuse the watched string
        setValue(endDateName, startDate || null, {
            shouldValidate: true,
            shouldDirty: true,
        });
    }, [startDate, endDateName, setValue]);

    return (
        <>
            <Grid item xs={12} sm={6}>
                <FormDatePicker
                    name={startDateName}
                    label={startDateLabel}
                    disabled={disabled}
                    disableFuture={disableFuture}
                    minDate={DateUtil.parseDateFromApi(minStartDate)}
                    rules={{
                        required: required,
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <FormDatePicker
                    name={endDateName}
                    label={endDateLabel}
                    disabled={true}
                    disableFuture={disableFuture}
                    maxDate={DateUtil.parseDateFromApi(maxEndDate)}
                    rules={{
                        required: required,
                    }}
                />
            </Grid>
        </>
    );
};

export default FormDatePickerCombo;
